import { render, staticRenderFns } from "./coaching.vue?vue&type=template&id=46b9072d&scoped=true"
import script from "./coaching.vue?vue&type=script&lang=js"
export * from "./coaching.vue?vue&type=script&lang=js"
import style0 from "./coaching.vue?vue&type=style&index=0&id=46b9072d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9072d",
  null
  
)

export default component.exports